import axios from 'axios';
import setAuthorizationHeader from '../utils/setAuthorizationHeader';
import {setAuthToken, removeAuthToken} from './authTokenStorage';

const instance = new axios.create({
    baseURL: (process.env.NODE_ENV === 'development') ?
        process.env.REACT_APP_API_URL_DEV : process.env.REACT_APP_API_URL_PROD
});

instance.interceptors.response.use(function (response) {
    const newToken = response.headers.authorization;
    if (newToken) {
        setAuthToken(newToken);
        setAuthorizationHeader(newToken);
    };
    return response;
}, function (error) {
    // Do something with response error
    if (!error || !error.response) {
        return Promise.reject(error);
    }

    const status = error.response.status;
    const requestUrl = (error.config && error.config.url) ? String(error.config.url) : '';
    const isUserLogTrackApi = requestUrl.indexOf('user-logs/track') !== -1;

    // Don't hard-logout when only menu tracking fails.
    if (status === 401 && !isUserLogTrackApi) {
        removeAuthToken();
        setAuthorizationHeader();
        window.location.replace('/');
        //store.dispatch(authLogoutAction());
    }
    return Promise.reject(error);
});

export default instance;
